import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { ModalLayout } from '@/components/layouts';
import { YesNoModalType } from '@/types';

export const YesNoModal = ({
  isOpen,
  onDeny,
  onConfirm,
  message = '',
  onClose
}: YesNoModalType) => {
  const [t] = useTranslation('common');

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className='inline-flex size-full flex-col items-center justify-center gap-y-6'>
        <div className='flex w-full flex-col items-center break-words'>
          <Trans i18nKey={t(message)} />
          <div className='flex w-full justify-center gap-x-5 p-5'>
            <Button variant={ButtonVariant.PRIMARY} handleOnClick={onDeny}>
              {t('no')}
            </Button>
            <Button variant={ButtonVariant.PRIMARY} handleOnClick={onConfirm}>
              {t('yes')}
            </Button>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};
